
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-gpk/pegawai/perencanaan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-gpk/pegawai/perencanaan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-gpk/pegawai/perencanaan"])
      });
    }
  